(function () {
  'use strict';

  function start() {
    try {
      var code = new URLSearchParams(window.location.search).get('discount');
      var excludedPaths = ['/checkout', '/admin', '/account', '/cart'];

      if (!code || excludedPaths.some(function (path) {
        return window.location.pathname.indexOf(path) === 0;
      })) {
        return;
      }

      var applying = false;

      function hasDiscount(cart) {
        return Array.isArray(cart.discount_codes) && cart.discount_codes.some(function (discount) {
          return discount && discount.code === code;
        });
      }

      function getCart() {
        return fetch('/cart.js').then(function (response) {
          if (!response.ok) {
            throw new Error('Unable to read cart');
          }
          return response.json();
        });
      }

      function applyDiscount() {
        if (applying) {
          return Promise.resolve();
        }

        applying = true;
        return getCart().then(function (cart) {
          if (hasDiscount(cart)) {
            return null;
          }

          return fetch('/cart/update.js', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({discount: code})
          }).then(function (response) {
            if (!response.ok) {
              throw new Error('Unable to update cart');
            }
            return response.json();
          }).then(function (updatedCart) {
            if (hasDiscount(updatedCart)) {
              document.dispatchEvent(new CustomEvent('cart:updated', {
                detail: {discount: code}
              }));
              console.info('Discount applied:', code);
            }
          });
        }).catch(function () {
          return null;
        }).then(function () {
          applying = false;
        }, function () {
          applying = false;
        });
      }

      getCart().then(function (cart) {
        if (cart.item_count === 0) {
          document.addEventListener('cart:updated', applyDiscount);
          document.addEventListener('cart-updated', applyDiscount);
        }

        if (!hasDiscount(cart)) {
          applyDiscount();
        }
      }).catch(function () {
        return null;
      });
    } catch (error) {
      return;
    }
  }

  try {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, {once: true});
    } else {
      start();
    }
  } catch (error) {
    return;
  }
}());
